import { Id } from "./id";

type Element = {
  type: "column" | "section";
  label: {
    fr: string;
    en: string;
  };
  key: string;
  elements: Element[];
};

type ConfigurationProfile = {
  roles: Id[];
  name: string;
  elements: Element[];
};

type ProjectDetailsConfiguration = ConfigurationProfile[];

const projectDetailsConfiguration: ProjectDetailsConfiguration = [];

export type { ProjectDetailsConfiguration };

export { projectDetailsConfiguration };
